import { useRef } from 'react';
import { useIsLoggedIn } from 'hooks/user/useIsLoggedIn';
import { useSearchParams } from 'hooks/useSearchParams';
import { AccountQueryKey } from 'constants/account/account-route-keys';
import { IS_KIOSK_GENERIC } from 'constants/app/configs';
import {
  ELsKeyAuthReachedFromOptions,
  ELsKeys
} from 'constants/app/storage-keys';

export const useCheckCreateNft = () => {
  const { modal } = useSearchParams();
  const { isLoginPending, isLoggedIn } = useIsLoggedIn();
  const firstRenderReference = useRef(true);

  const checkCreateNftRoute = () => {
    firstRenderReference.current = false;
    if (IS_KIOSK_GENERIC) {
      return;
    }
    if (modal !== AccountQueryKey.modal.option.CHOOSE_CREATE_NFT) {
      return;
    }
    if (!isLoggedIn && !isLoginPending) {
      localStorage.setItem(
        ELsKeys.AUTH_REACHED_FROM,
        ELsKeyAuthReachedFromOptions.CREATE_NFT
      );
    }
  };

  firstRenderReference.current && checkCreateNftRoute();
};
